import { render, staticRenderFns } from "./sysFooter.vue?vue&type=template&id=7b8ef9c3&scoped=true&"
import script from "./sysFooter.vue?vue&type=script&lang=js&"
export * from "./sysFooter.vue?vue&type=script&lang=js&"
import style0 from "./sysFooter.vue?vue&type=style&index=0&id=7b8ef9c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ef9c3",
  null
  
)

export default component.exports